import React from 'react';
import ASwipeAction from 'antd-mobile/lib/swipe-action';



export default class SwipeAction extends ASwipeAction {}